import React from "react";
import SellSim from "@/pages/SellSim";
import { WithOperator } from "@/components/mobile/WithOperator";

const canSell = (o) => ["attivazione", "ricarica", "info", "cambio_promo"].some((k) => o.features?.[k] !== false);

export default function MobileSell() {
  return <WithOperator choose only={canSell} title="Attiva e gestisci SIM" testid="mobile-sell-page" description="Scegli l'operatore, poi attiva, ricarica, controlla o cambia la promo di una SIM. Le pratiche vengono lavorate dalla coda Admin.">
    <SellSim embedded />
  </WithOperator>;
}
